import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/colocess_web_manage/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  components: {
    Editor: Editor
  },
  props: {
    GamesServersList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      form: {
        game_server_id: '',
        product_name: '',
        icon: '',
        currency: '',
        price: '',
        content: '',
        state: '',
        cp_product: '',
        params: []
      },
      stateList: [{
        label: '启用',
        value: 2
      }, {
        label: '禁用',
        value: 1
      }, {
        label: '敬请期待',
        value: 3
      }],
      copyform: {},
      picfileList: [],
      dialogShow: false,
      rules: {
        game_server_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        product_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        icon: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        currency: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        price: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        state: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    this.copyform = _objectSpread({}, this.form);
    this.getlangList();
  },
  methods: {
    init: function init(datas) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, lang, list;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogShow = true;

                if (datas) {
                  data = JSON.parse(JSON.stringify(datas));
                  lang = data.language ? data.language.split(',') : [];
                  list = [];
                  lang.forEach(function (i) {
                    list.push(data.params.findIndex(function (j) {
                      return j.language == i;
                    }) > -1 ? _objectSpread(_objectSpread({}, data.params.find(function (j) {
                      return j.language == i;
                    })), {}, {
                      languageName: _this.languageList.find(function (j) {
                        return j.sign == i;
                      }).name
                    }) : _objectSpread(_objectSpread({}, _this.paramsMark), {}, {
                      language: i,
                      languageName: _this.languageList.find(function (j) {
                        return j.sign == i;
                      }).name
                    }));
                  });
                  list.map(function (i) {
                    i.picfileList = [i.icon];
                  });
                  data.params = list;
                  _this.form = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clearData: function clearData() {
      this.$refs.ruleForm.resetFields();
    },
    getlangList: function getlangList() {
      var _this2 = this;

      this.$api.languageInfoData().then(function (res) {
        if (res.code == 0) {
          _this2.languageList = res.data;
        }
      });
    }
  }
};